import { MAP_COUNTRIES } from "@/data/map-countries";

const BY_SLUG = new Map(MAP_COUNTRIES.map((c) => [c.slug, c]));

/** Landmark cover image for a country slug, used for og:image / image sitemap. */
export function countryImage(slug: string): string | undefined {
  return BY_SLUG.get(slug)?.image;
}
